export const Types = {
  BUILDER_UPDATE_COMPONENT_PAYLOAD: 'BUILDER_UPDATE_COMPONENT_PAYLOAD',
};

export const updateComponentPayload = (id, newPayload) => ({
  type: Types.BUILDER_UPDATE_COMPONENT_PAYLOAD,
  payload: { id, newPayload },
});
